import { createRoutine } from 'redux-saga-routines';

export const togglePositionProfileRoutine = createRoutine('TOGGLE_POSITION_PROFILE');

export const fetchPositionRoutine = createRoutine('FETCH_POSITION');
export const fetchPositionCountersRoutine = createRoutine('FETCH_COUNTERS_POSITION');

export const fetchCandidatesByPositionIdRoutine = createRoutine('FETCH_CANDIDATES_POSITION');

export const changePositionNameRoutine = createRoutine('CHANGE_POSITION_NAME');
export const checkPositionNameRoutine = createRoutine('CHECK_POSITION_NAME');
export const setNewPositionNameRoutine = createRoutine('SET_NEW_POSITION_NAME');
